module.exports = __webpack_public_path__ + "img/communic.437bcb56.jpg";